import {useState, useEffect} from 'react'
import {Col} from 'react-bootstrap'
import '../Overview.css'
import UserService from '../../../../../services/user'
import MasterService from '../../../../../services/master'
import useServices from '../../../../../utils/hooks/useServices'
import FormCompany from './Forms'
import {ProfileHeader} from '../../ProfileHeader'
import {PageTitle} from '_metronic/layout/core'

const InformationCompany = () => {
  return (
    <div>
      <ProfileHeader />
      <div className='row'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-6'>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Dashboard',
                    path: '/dashboard',
                    isSeparator: false,
                    isActive: false,
                  },
                  {
                    title: '/',
                    path: '',
                    isSeparator: false,
                    isActive: false,
                  },
                ]}
              >
                Edit Informasi Perusahaan
              </PageTitle>
            </div>
          </div>
        </div>
        <h4> Edit Informasi Perusahaan</h4>
        <Col md={12} className='mt-8'>
          <FormCompany />
        </Col>
      </div>
    </div>
  )
}

export default InformationCompany
